import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private readonly _oauthService: AuthService = inject(AuthService);

  getBearerToken(): string | null {
    const token = sessionStorage.getItem('sf_access_token');
    return token;
  }

  getRequestId(): string {
    return window.crypto.randomUUID();
  }

  getCurrentDate(): string {
    const date = new Date();
    return date.toLocaleDateString('en-GB'); // Formats as DD/MM/YYYY
  }

  async reAttemptIfTokenExpiry(callback: () => void) {
    const loginSuccess = await this._oauthService.tryReauthenticate('FRONTEND error: tryReauthenticate failed');
    if (loginSuccess) {
      // Retry fetch after reauth
      setTimeout(() => callback(), 0);
    } else {
      throw 'Reauth didnt Work. Session expired.';
    }
  }
}
